import { useState } from 'react';
import type { Store } from 'antd/es/form/interface'; // Import the type for the form values
import type { ValidateErrorEntity } from 'rc-field-form/lib/interface'; // Import the correct type for errorInfo
import { DEFAULT_COUNTRY_CODE, LOCAL_AR, LOCAL_EN, ROUTE } from '@/config';
import { useTranslation } from 'react-i18next';
import { useGetMessagingToken, useSetLogin } from '@/hooksApi';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '@/stores';
import { message } from 'antd';
import { attachCountryCodeToPhone } from '@/utils';
import type { MenuInfo } from 'rc-menu/lib/interface';
import useLanguageStore, { LanguageType } from '@/stores/useLanguageStore';
// TODO: Zendesk temporarily disabled due to migration.
// Replace with new chat provider when ready.
// import useZendesk from './useZendesk';

const useLogin = () => {
  // const [direction, setDirection] = useState('ltr');
  const [countryCode, setCountryCode] = useState(DEFAULT_COUNTRY_CODE); // Default country code
  const { i18n, t } = useTranslation();
  const navigation = useNavigate();
  const setHash = useUserStore((state) => state.setHash);
  const { language, setLanguage } = useLanguageStore();

  // const { loginZd } = useZendesk();

  const { mutate: loginUser, isLoading } = useSetLogin();

  const { mutate: getZdToken } = useGetMessagingToken();

  const onFinish = (values: Store) => {
    const phoneNumber = attachCountryCodeToPhone(values.phoneNumber, values.countryCode);

    loginUser(
      {
        phone: phoneNumber || '',
      },
      {
        onSuccess: (data) => {
          navigation(ROUTE.VERIFY, { state: { phoneNumber } });
          setHash(data?.object?.hash);
          // todo
          // getZdToken(undefined, {
          //   onSuccess: (data) => {
          //     loginZd(data.object.token);
          //   },
          // });
        },
      },
    );
  };

  const onFinishFailed = (errorInfo: ValidateErrorEntity) => {
    console.error('Failed:', errorInfo);
  };

  // const toggleDirection = () => {
  //   i18n.changeLanguage(i18n.language === LOCAL_EN ? LOCAL_AR : LOCAL_EN);
  //   // setDirection((prevDirection) => (prevDirection === 'ltr' ? 'rtl' : 'ltr'));
  // };
  const toggleDirection = (e: MenuInfo) => {
    //i18n.changeLanguage(i18n.language === LOCAL_EN ? LOCAL_AR : LOCAL_EN);
    const language = e.key as LanguageType;
    // i18n.changeLanguage(language);
    setLanguage(language);
  };

  return {
    // direction,
    countryCode,
    setCountryCode,
    onFinish,
    onFinishFailed,
    toggleDirection,
    isLoading,
  };
};
export default useLogin;
